<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Blocked CPR Numbers</h4>
        </div>
        <div class="card-body">
          <div class="row mb-4">
            <div class="col-md-6">
              <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
                <div class="input-group">
                  <input type="text" class="form-control" formControlName="search" placeholder="Search CPR number...">
                  <button class="btn btn-primary" type="submit">Search</button>
                </div>
              </form>
            </div>
            <div class="col-md-6 text-right">
              <a [routerLink]="['/blocked-cpr/add']" class="btn btn-primary me-2">
                <i class="fa fa-plus"></i> Add CPR
              </a>
              <a [routerLink]="['/blocked-cpr/upload']" class="btn btn-primary">
                <i class="fa fa-upload"></i> Upload CSV
              </a>
            </div>
          </div>
          
          <div *ngIf="loading" class="text-center my-5">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          
          <div *ngIf="!loading" class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>CPR Number</th>
                  <th>Reason</th>
                  <th>Blocked By</th>
                  <th>Date Blocked</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let cpr of blockedCprs">
                  <td>{{ cpr.cprNumber }}</td>
                  <td>{{ cpr.reason || '-' }}</td>
                  <td>{{ cpr.blockedBy?.name || '-' }}</td>
                  <td>{{ cpr.createdAt | date:'medium' }}</td>
                  <td>
                    <span [ngClass]="{'badge bg-success': cpr.status === 1, 'badge bg-secondary': cpr.status !== 1}">
                      {{ cpr.status === 1 ? 'Active' : 'Inactive' }}
                    </span>
                  </td>
                  <td>
                    <button class="btn btn-sm btn-danger" (click)="deleteBlockedCpr(cpr._id)">
                      <i class="fa fa-trash"></i> Delete
                    </button>
                  </td>
                </tr>
                <tr *ngIf="blockedCprs.length === 0">
                  <td colspan="6" class="text-center">No blocked CPR numbers found</td>
                </tr>
              </tbody>
            </table>
            
            <!-- Pagination -->
            <div *ngIf="totalPages > 1" class="d-flex justify-content-center mt-4">
              <nav>
                <ul class="pagination">
                  <li class="page-item" [class.disabled]="currentPage === 1">
                    <a class="page-link" (click)="changePage(currentPage - 1)" role="button">Previous</a>
                  </li>
                  <li class="page-item" *ngFor="let page of getPages()" [class.active]="currentPage === page">
                    <a class="page-link" (click)="changePage(page)" role="button">{{ page }}</a>
                  </li>
                  <li class="page-item" [class.disabled]="currentPage === totalPages">
                    <a class="page-link" (click)="changePage(currentPage + 1)" role="button">Next</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> 